<template>
  <div
    :class="{'gc-navigator-bottom-bar__link--active': active }"
    class="gc-navigator-bottom-bar__link gc-navigator-bottom-bar__link--meal"
    @click="clicked()">
    <div class="gc-navigator-bottom-bar__icon">
      <icon-meal
        v-if="active"
        :size="'md1'"
        class="gc-navigator-bottom-bar__link-icon gc-navigator-bottom-bar__link-icon--active"/>
      <icon-meal
        v-else
        :size="'md1'"
        class="gc-navigator-bottom-bar__link-icon"/>
      <icon-underline/>
    </div>
  </div>
</template>
<script>
import IconMeal from '../../../root/icons/IconMeal'
import IconMealPlanLinear from '../../../root/icons/IconMealPlanLinear'
import IconMealPlanFilled from '../../../root/icons/IconMealPlanFilled'
import IconDot from '../../../root/icons/IconDot'
import IconUnderline from '@/components/root/icons/IconUnderline.vue'

export default {
  name: 'NavigatorBottomBarLinkMeal',
  components: {
    IconUnderline,
    IconDot,
    IconMealPlanLinear,
    IconMealPlanFilled,
    IconMeal
  },
  props: {
    active: {
      default: false
    }
  },
  methods: {
    clicked () {
      this.$emit('click')
    }
  }
}
</script>
